// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2ZMf-","cell":"ColumnAccessor_cell__2eq92","firstCellAccent":"ColumnAccessor_firstCellAccent__SvlGK"};